<markant-platform-ui-card
  class="management-tile"
  [headline]="'cartridge.management.documents.title' | transloco"
>
  <p>{{ 'cartridge.management.documents.info' | transloco }}</p>
  <div footer class="management-tile-footer">
    <a
      class="link"
      [class.link--disabled]="
        bookingState === 'PENDING' || bookingState === 'DECLINED'
      "
      [routerLink]="['documents']"
      [state]="filterInvoiceState"
    >
      {{ 'cartridge.management.documents.action.invoice' | transloco }}
      <markant-icon class="link-icon" icon="m_arrow-right-small"></markant-icon>
    </a>
    <a
      class="link"
      [class.link--disabled]="
        bookingState === 'PENDING' || bookingState === 'DECLINED'
      "
      [routerLink]="['documents']"
      [state]="filterServiceConditionsState"
    >
      {{ 'cartridge.management.documents.action.contract' | transloco }}
      <markant-icon class="link-icon" icon="m_arrow-right-small"></markant-icon>
    </a>

    <a *ngIf="priceRequestId" class="link" (click)="showOfferDocument()">
      {{
        'booking.requests.detail.paymentDetails.viewPriceOfferDocument'
          | transloco
      }}
      <markant-icon class="link-icon" icon="m_arrow-right-small"></markant-icon>
    </a>
  </div>
</markant-platform-ui-card>
